import { render, staticRenderFns } from "./StoriesManage.vue?vue&type=template&id=28b67cf0&scoped=true"
import script from "./StoriesManage.vue?vue&type=script&lang=js"
export * from "./StoriesManage.vue?vue&type=script&lang=js"
import style0 from "./StoriesManage.vue?vue&type=style&index=0&id=28b67cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b67cf0",
  null
  
)

export default component.exports